import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Unified back button used across ALL sub-views.
 * Consistent size, style, and positioning.
 */
export default function BackButton({ onClick, label = 'Back' }) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="mb-4 text-sm font-medium gap-1.5 h-9 px-3"
      data-testid="back-button"
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
}
